export default class Others {
    constructor(_id, _FirstName, _LastName, _DateOfBirth) {
      this.id = _id;
      this.FirstName = _FirstName;
      this.LastName = _LastName;
      this.DateOfBirth = _DateOfBirth;
    }
  }